export const environment = {
  production: true,
  urlApi: "https://telar-client-be-qa.azurewebsites.net/api/v1",
  rootUrl: 'https://telar-client-fe-qa.azurewebsites.net',
  encryptKey: '1203199302112022',
  lastOrganizationKey: 'lastOrganization',
  queriesEntityId: 'e834b7a5-567e-4a97-bd93-8a9f8a2c9679',
  dynamicCardsEntityId: 'D4E5F6A7-B8C9-4D0E-8F1A-2B3C4D5E6F7A',
  dashboardsEntityId: '16273F1A-5520-4489-983F-D487022C87C8',
  dynamicFormsEntityId: '3F2504E0-4F89-11D3-9A0C-0305E82C3301',
  dynamicConversationsEntityId: "A1B2C3D4-E5F6-7890-1234-56789ABCDEF0",
  chatContextsEntityId: 'D1E2F3A4-B5C6-7890-1234-56789ABCDEF0',
  documentsEntityId: 'F0E1D2C3-B4A5-6789-0123-456789ABCDEF',
  meetingsEntityId: 'A1234567-B89C-1234-D567-890123456789',
  iaModelsEntityId: 'B7A1C2D3-E4F5-6789-ABCD-1234567890AB',
  cotextMasterEtityId: 'E74D35F2-9A1C-4B76-9463-0D8C307F1EAF',
  recruitmentProcessEntityId: 'A1000000-0000-0000-0000-000000000001',
  recruitmentProcessStepsEntityId: 'A1000000-0000-0000-0000-000000000002',
  recruitmentProcessInterviewEntityId: 'A1000000-0000-0000-0000-000000000003',
  recruitmentProcessResultEntityId: 'A1000000-0000-0000-0000-000000000004',
  templatePromptsEntityId: 'A1000000-0000-0000-0000-000000000005',
    processConfigEntityId: "A1000000-0000-0000-0000-000000000006",
      personEntityId: 'A1000000-0000-0000-0000-000000000007',
  assistantEntityId: 'E0A1B2C3-D4F5-6789-ABCD-1234567890AC',
  mcpServersEntityId: 'D0C0B0A0-1234-5678-9ABC-DEF012345678',
    assistantMcpConfigurationId: 'C1B1A191-2345-6789-BCDE-EF0123456789' ,
  userAssistantContextEntityId: 'A2B2C2D2-3456-7890-CDEF-0123456789AB',



};
